<template>
  <vx-card :title="visibleRes && form.getFieldValue('from_date') ?`Tax Report From ${form.getFieldValue('from_date')} To ${form.getFieldValue('to_date')}` :title">
    <div v-show="visibleRes">
      <Actions
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result && result.length">
        <div ref="contentPdf">
          <a-table :dataSource="result" :columns="columns" :pagination="false" class="tbl-receivable" >
          <span slot="date" slot-scope="text,record">
            {{ setDateFormat(record.from) + ' - ' + setDateFormat(record.to) }}
          </span>
          <span slot="tax_rate_primary" slot-scope="text,record">
            {{ text + '%' }}
          </span>
          <span slot="tax_rate_secondary" slot-scope="text,record">
            {{ text + '%' }}
          </span>
        </a-table>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <div v-show="!visibleRes">
      <a-form :form="form" @submit.prevent="handleReport">
        <div class="grid grid-cols-1 w-full md:w-1/2">
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Responsible Lawyer">
              <a-radio-group
                v-decorator="['which_user',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]"
                @change="handleChangeUser">
                <a-radio :style="radioStyle" :value="1">
                  All Lawyers
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Responsible Lawyer
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <SelectOption
              v-show="responsible_value === 2"
              url="/account/list/"
              label="User"
              field="user"
              :required="false"
              method="get"
              mode="multiple"
              placeholder="Find A User"
              class="w-full self-end"
            />
          </div>
          <SelectOption url="/dictionary/practice-area/" label="Practice Area" placeholder="Practice Area"
                        field="practice_area" method="get"/>
          <DateRangeComponent :dateForm="form" class="mt-5"/>
        </div>
        <BtnSubmitReport
          ref="reportSubmit"
          @backPage="$emit('changeTab','RevenueReport')"
        />
      </a-form>
    </div>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      :pdfForm="form.getFieldsValue(['from_date','to_date'])"
      @onProgress="onProgress"
      @hasDownloaded="hasDownloaded"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>
<script>

import SelectOption from '../../forms/SelectOptionSingle'
import selectSearch from '../../forms/selectSearch'
import axios from '@/axios'
import mixin from '../../mixin/mixin'
import DateRangeComponent from "@/components/date/DateRangeComponent";
import Actions from "@/components/closeDownloadReport/Actions";
import ExportPdf from "@/components/pdf/ExportPdf";
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";

const columns = [
  {
    title: 'Date',
    dataIndex: 'from',
    key: '1',
    scopedSlots: {customRender: 'date'},
  },
  {
    title: 'Invoice Amount',
    dataIndex: 'total',
    key: '2',
  },
  {
    title: 'Rate',
    dataIndex: 'rate',
    key: '3',
    scopedSlots: {customRender: 'tax_rate_primary'},
  },
  {
    title: 'Total Tax',
    dataIndex: 'total_tax',
    key: '4',
  }
]

export default {
  name: "ComponentGeneral",
  mixins: [mixin],
  components: {
    BtnSubmitReport,
    ExportPdf,
    Actions,
    DateRangeComponent,
    SelectOption,
    selectSearch
  },
  data() {
    return {
      responsible_value: null,
      title: 'Tax Report',
      columns,
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '30px',
      },
    }
  },
  methods: {
    handleChangeUser({target: {value}}) {
      if (value === 1)
        this.form.setFieldsValue({ user: [] })
      this.responsible_value = value
    },
    handleReport() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.$refs.reportSubmit.loading = true
            const query = []
            if (values.practice_area) query.push({
              field: 'matters__practice_area',
              condition: '=',
              value: values.practice_area
            })
            if (values.user && values.user.length) query.push({field: 'matters__responsible', condition: 'in', value: values.user})
            const {data} = await axios.post('billing/report/tax/', {query: query.length ? query : undefined,from : values.from_date, to: values.to_date})

            if (data && data.error) {
              const error = new Error(data.error)
              error.status = 500
              throw error
            }
            
            this.visibleRes = true
            this.result.push(data)
          } catch (e) {
            this.visibleRes = false
            if (e.status === 500) {
              this.$message.error('your tax rate is different in this period.')
            }
            throw new Error(e)
          } finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    }
  }
}
</script>

<style>
@import "../../style/style.css";
</style>

